import React from 'react';
import ClientProjectItem from '../../../Domain/ClientProjectItem';
import ProjectItem from '../../../Domain/ProjectItem';
import ButtonRow from '../../../Elements/ButtonRow';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ErrorMessage from '../../../Elements/ErrorMessage';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import urlHelper from '../../../Helpers/urlHelper';
import ClientService from '../../../Services/clientService';
import OperationsProjectService from '../../../Services/OperationsProjectService';
import OpportunityService from '../../../Services/opportunityService';
import AddProjectWindowDescription from './AddProjectWindowDescription';
import EditProjectWindowDescription from './EditProjectWindowDescription';
import Loading from '../../../Elements/loading';

export default class ProjectComponent extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      logList: [],
      selectedLogId: -1,
      selected: -1,
      selectedItem: null,
      orderBy: 'Id',
      orderDirection: OrderDirectionsEnum.Asc,
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      clientId: props.ClientId,
      loading: false,
    };

    ProjectItem.editFunction = this.clickOnEditIcon.bind(this);
    this.itemEditedFunction = this.itemEditedFunction.bind(this);

    this.CfOpportunityId = '';
    this.CfLdvid = '';
    this.CfStartDate = '';
    this.CfEndDate = '';
  }

  async clickOnEditIcon(selectedId, selectedItem) {
    this.setState({ loading: true });
    OperationsProjectService.GetIsProjectInvoicedById(selectedItem.CfId)
      .then((isInvoiced) => {
        this.setState({
          selectedItem: { ...selectedItem, IsInvoiced: isInvoiced },
          shownPanel: ShownPanelsEnum.EditItem,
          loading: false,
        });
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage(
          "PA62 - Can't get project invoiced status. You won't be able to edit the reimbursement type."
        );
        this.setState({
          selectedItem: { ...selectedItem, IsInvoiced: true },
          shownPanel: ShownPanelsEnum.EditItem,
          loading: false,
        });
      });
  }

  async itemEditedFunction(editedItem) {
    if (this.CfOpportunityId !== editedItem.CfOpportunityId) {
      this.CfOpportunityId = editedItem.CfOpportunityId;

      if (editedItem.CfOpportunityId === '') {
        editedItem.CfRcyid = '';
        editedItem.CfServiceId = '';
      } else {
        const oppCurr = await OpportunityService.GetOpportunityCurrencyCode(editedItem.CfOpportunityId);
        editedItem.CfRcyid = oppCurr.toString();
      }
    }

    if (this.CfStartDate !== editedItem.CfStartDate) {
      this.CfStartDate = editedItem.CfStartDate;
      editedItem.CfOpportunityId = '';
    }

    if (this.CfEndDate !== editedItem.CfEndDate) {
      this.CfEndDate = editedItem.CfEndDate;
      editedItem.CfOpportunityId = '';
    }

    return editedItem;
  }

  componentDidMount() {
    ClientService.GetClientList(this.state.clientId)
      .then((result) => {
        this.CfLdvid = result.officeId;
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('PC74');
      });
  }

  editPanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.CfOpportunityId = '';
  }

  savePanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });

    this.CfOpportunityId = '';
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderPanels() {
    if (this.state.shownPanel === ShownPanelsEnum.EditItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={this.state.selectedItem}
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={EditProjectWindowDescription}
          errorCode={'PC120'}
        />
      );
    }
    if (this.state.shownPanel === ShownPanelsEnum.AddNewItem) {
      const tempProjectItem = new ProjectItem();
      tempProjectItem.ClientId = this.state.clientId;
      tempProjectItem.CfRcyid = this.CfRcyid;
      tempProjectItem.CfLdvid = this.CfLdvid;
      this.CfStartDate = tempProjectItem.CfStartDate;
      this.CfEndDate = tempProjectItem.CfEndDate;
      tempProjectItem.CfReimbTypeText = 'Use Apollo Client Reimbursement Field';

      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={tempProjectItem}
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={AddProjectWindowDescription}
          onChangeEditedItem={this.itemEditedFunction}
          errorCode='PC141'
        />
      );
    }
    return null;
  }

  render() {
    return this.state.loading ? (
      <Loading />
    ) : (
      <div>
        <ButtonRow
          labels={['Create']}
          colors={[ButtonColorsEnum.Primary]}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roleKeys={['project_edit']}
          className={'InnerMenuButtonFigmaList'}
          value={this.state.shownPanel}
          onClick={() => this.setState({ shownPanel: ShownPanelsEnum.AddNewItem })}
        />
        <TabOfDataTable
          type={ClientProjectItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={OperationsProjectService.GetProjectList}
          convertDBItemsFunction={OperationsProjectService.ConvertDBItemList}
          searchItem={{ ClientIdOrName: this.state.clientId }}
          orderDirection={OrderDirectionsEnum.Desc}
          redirectLinkOnInfo={urlHelper.generateRedirectUrlWithMultipleParameters('projects', [
            { key: 'OfficeName', value: '' },
            { key: 'ProjectIdOrName', value: '' },
          ])}
          errorCode='PC171'
        />
        {this.renderPanels()}
      </div>
    );
  }
}

